import React, { memo, useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import CustomSuffixIcon from "./CustomSuffixIcon";

import axios from "axios";
import axiosInstance from "../../axios/axios";
import { fileurl } from "../../axios/url.js";
import { Decrypt_Value, Encrypt_Value } from "../../MiddleWare/EncryptDecrypt";
import { AutoComplete, Select, DatePicker } from "antd";
import { AiOutlineSearch } from "react-icons/ai";
import moment from "moment";
import { BsCheckCircle } from "react-icons/bs";
import { useLocation, useHistory } from "react-router-dom";
import { Popup } from "semantic-ui-react";
import GetStartedPopup from "./GetStartedPopup";

const CreateGroupClients = ({ onClose, editData, onSuccess }) => {
  const location = useLocation();
  const history = useHistory();
  const [isPopup3Open, setIsPopup3Open] = useState(false);

  useEffect(() => {
    if (location?.state?.patientgroupstarted3) {
      setIsPopup3Open(true);
    }
  }, [location?.state?.patientgroupstarted3]);
  const [providerID, setproviderID] = useState("");
  const [providerlist, getproviderlist] = useState([]);
  const [provErr, setProvErr] = useState(false);
  const { Option } = Select;
  const [countryCodes, setCountryCodes] = useState([]);
  const [search, setSearch] = useState("");
  const [source, setSource] = useState([]);
  const [fornoresults, setfornoresults] = useState("1");
  const [forpatsrchload, setforpatsrchload] = useState(false);
  const [patsrchvalue, setpatsrchvalue] = useState("");
  const [showTitle, setShowTitle] = useState(true);
  const [patname, setpat] = useState(""); //

  const dtFormat = localStorage.getItem("dateFormat");

  const storedNames = Decrypt_Value(localStorage.getItem("setroles"), "vozo");
  const userID = Decrypt_Value(localStorage.getItem("user_id"), "vozo");
  const authorized = Decrypt_Value(localStorage.getItem("authorized"), "vozo");
  const main_pro = Decrypt_Value(localStorage.getItem("main_pro"), "vozo");
  const owner_id = Decrypt_Value(localStorage.getItem("owner_id"), "vozo");
  let user_ID = Decrypt_Value(localStorage.getItem("user_id"), "vozo");

  const [status, setStatus] = useState("active");
  const [statusErr, setStatusErr] = useState(false);

  //   create group client
  const [groupName, setGroupName] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [maxAttendees, setMaxAttendees] = useState("");
  const [patientErr, setPatientErr] = useState("");

  const [groupNameErr, setGroupNameErr] = useState(false);
  const [dateErr, setDateErr] = useState(false);
  const [maxErr, setMaxErr] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");

  const [showMessage, setShowMessage] = useState(false);
  const [messageType, setMessageType] = useState("success"); // success | danger
  const [messageText, setMessageText] = useState("");

  const [selectedPatients, setSelectedPatients] = useState([]);
  const statusSetVal = (value) => {
    setStatus(value);
    setStatusErr(false);
  };

  const provIdSetVal = (val) => {
    setproviderID(String(val));
    setProvErr(false);
  };

  const PatientSelect = (data) => {
    const pid = data.split("-")[0];

    // Find full patient object from search result
    const patientObj = source.find((p) => String(p.pid) === String(pid));
    if (!patientObj) return;

    // Max attendee check
    if (maxAttendees && selectedPatients.length >= Number(maxAttendees)) {
      alert(`You can select only ${maxAttendees} patients`);
      return;
    }

    // Prevent duplicate
    setSelectedPatients((prev) => {
      if (prev.some((p) => p.pid === patientObj.pid)) return prev;
      return [...prev, patientObj];
    });

    // Clear search input only, KEEP the source data
    setSearch("");
    // DON'T clear source: setSource([]);
    setforpatsrchload(false);
  };

  const PatientSearch = (data) => {
    setfornoresults("1");
    // setSource([]);
    setforpatsrchload(true);
    setpatsrchvalue(data);
    setSearch(data);
    if (data === "") {
      setpat("");
    }
  };

  const resetForm = () => {
    setGroupName("");
    setproviderID("");
    setStatus("active");
    setStartDate("");
    setEndDate("");
    setMaxAttendees("");
    setSelectedPatients([]);
    setSearch("");
    setSource([]);
    setGroupNameErr(false);
    setProvErr(false);
    setStatusErr(false);
    setDateErr(false);
    setMaxErr(false);
  };

  const removePatient = (pid) => {
    setSelectedPatients((prev) => prev.filter((p) => p.pid !== pid));
  };

  const timeout = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const patdropdown = () => {
    let q =
      "limit=10&fname=" +
      search +
      "&authorized=" +
      authorized +
      "&main_pro=" +
      main_pro +
      "&userID=" +
      user_ID +
      "&pat_share=" +
      storedNames.pat_share +
      "&owner_id=" +
      owner_id;

    axiosInstance
      .get("/vozo/patientsearch?search=" + Encrypt_Value(q, "vozo"))
      .then((res) => {
        let d = Decrypt_Value(res.data, "vozo");
        setSource(d);
        setfornoresults(d.length > 0 ? "1" : "");
      })
      .catch(() => {
        setSource([]);
        setfornoresults("");
      });
  };

  // handelSave

  const handleSave = () => {
    let hasError = false;

    // Clear ALL previous messages and errors
    setShowMessage(false);
    setMessageText("");
    setGroupNameErr(false);
    setProvErr(false);
    setStatusErr(false);
    setDateErr(false);
    setMaxErr(false);
    setPatientErr("");

    if (!groupName.trim()) {
      setGroupNameErr(true);
      hasError = true;
    }

    if (!providerID) {
      setProvErr(true);
      hasError = true;
    }

    if (!status) {
      setStatusErr(true);
      hasError = true;
    }

    if (!startDate || !endDate || startDate > endDate) {
      setDateErr(true);
      hasError = true;
    }

    if (!maxAttendees || Number(maxAttendees) <= 0) {
      setMaxErr(true);
      hasError = true;
    }

    if (selectedPatients.length === 0) {
      setPatientErr("Please select at least one patient");
      hasError = true;
    } else if (selectedPatients.length > Number(maxAttendees)) {
      setPatientErr(`You can select only ${maxAttendees} patients`);
      hasError = true;
    }

    if (hasError) return;

    const payload = {
      id: editData ? editData.group_id : 0,
      group_name: groupName,
      provider_id: providerID,
      status: status,
      start_date: startDate,
      end_date: endDate,
      max_attendees: Number(maxAttendees),
      patients: selectedPatients.map((p) => ({
        pid: p.pid,
        name: p.title || p.name,
        dob: p.dob || "",
        phone: p.phone_cell || "",
        email: p.email || "",
        gender: p.sex || "",
      })),
    };

    const encryptedPayload = Encrypt_Value(payload, "vozo");
    const apiUrl = editData
      ? "/vozo/patientgroup/update"
      : "/vozo/patientgroup/create";

    axiosInstance
      .post(apiUrl, encryptedPayload)
      .then((res) => {
        const decrypted = Decrypt_Value(res.data, "vozo");

        console.log("Full API Response:", decrypted);

        // Clear all form errors before checking API response
        setGroupNameErr(false);
        setShowMessage(false);

        // Check if group_id is a string containing JSON error
        if (
          decrypted &&
          decrypted.group_id &&
          typeof decrypted.group_id === "string"
        ) {
          try {
            const groupIdData = JSON.parse(decrypted.group_id);

            // If group_id contains error, it's a duplicate
            if (groupIdData && groupIdData.status === "error") {
              // Set ONLY the API error, not the validation error
              setGroupNameErr(true); // This triggers red border
              setMessageType("danger");
              setMessageText(
                groupIdData.message || "Group name already exists",
              );
              setShowMessage(true);
              return;
            }
          } catch (e) {
            console.log("group_id is not JSON:", e);
          }
        }

        // Also check the whole response as string for error
        const responseString = JSON.stringify(decrypted).toLowerCase();
        if (responseString.includes("already exists")) {
          setGroupNameErr(true);
          setMessageType("danger");
          setMessageText("Group name already exists");
          setShowMessage(true);
          return;
        }

        // If outer status is true and no error found, it's success
        if (decrypted && decrypted.status === true) {
          onSuccess(
            editData
              ? "Patient Group updated successfully"
              : "Patient Group created successfully",
          );
          setShowSuccess(true);
          setTimeout(() => {
            setShowSuccess(false);
            setSuccessMsg("");
            onClose();
          }, 2000);
          return;
        }

        // Fallback success if we get here
        onSuccess(
          editData
            ? "Patient Group updated successfully"
            : "Patient Group created successfully",
        );
        setShowSuccess(true);
        setTimeout(() => {
          setShowSuccess(false);
          setSuccessMsg("");
          onClose();
        }, 2000);
      })
      .catch((error) => {
        console.error("API Error:", error);
        setMessageType("danger");
        setMessageText("Something went wrong. Please try again");
        setShowMessage(true);
      });
  };

  useEffect(() => {
    if (!editData) return;
    console.log("editData", editData);

    setGroupName(editData.group_name || "");
    setStatus(editData.status || "active");
    setStartDate(editData.start_date || "");
    setEndDate(editData.end_date || "");
    setMaxAttendees(editData.max_attendees || "");
    console.log(editData.patient_array, "patient_array");

    if (Array.isArray(editData.patient_array)) {
      const normalizedPatients = editData.patient_array.map((p) => ({
        pid: p.pid,
        name: p.name || p.title,
        title: p.name || p.title,
      }));
      console.log(normalizedPatients, "normalizedPatients");

      setSelectedPatients(normalizedPatients);
    }
  }, [editData]);

  useEffect(() => {
    if (!editData || providerlist.length === 0) return;

    const provider = providerlist.find(
      (p) => `${p.fname} ${p.lname}` === editData.provider_name,
    );

    if (provider) {
      setproviderID(String(provider.id));
    }
  }, [editData, providerlist]);

  // fetch data

  useEffect(() => {
    let cancel = false;
    const handler = async () => {
      await timeout(600);
      if (!cancel && forpatsrchload) patdropdown();
    };
    handler();
    return () => (cancel = true);
  }, [patsrchvalue]);

  useEffect(() => {
    const fetchApis = async () => {
      await axios
        .get(fileurl + "/interface/register/get_country_code_rpm.php")
        .then((res) => {
          setCountryCodes(res.data);
        })
        .catch((err) => {
          console.error(err);
          setCountryCodes([]);
        });

      let Data_frsh =
        "limit=40&authorized=" +
        authorized +
        "&main_pro=" +
        main_pro +
        "&owner_id=" +
        owner_id +
        "&userID=" +
        userID +
        "&pat_share=" +
        storedNames.pat_g;

      let Data_enc = Encrypt_Value(Data_frsh, "vozo");
      await axiosInstance
        .get("/vozonew/provider?search=" + Data_enc)
        .then((response) => {
          let DecodeVal = Decrypt_Value(response.data, "vozo");
          const normalized = DecodeVal.map((p) => ({
            ...p,
            id: String(p.id),
          }));

          getproviderlist(normalized);
          // getproviderlist(DecodeVal);
        })
        .catch((err) => {
          getproviderlist([]);
        });
    };

    fetchApis();
  }, []);
  return (
    <>
      {/* ===== Modal Header ===== */}
      <Modal.Header closeButton>
        <Modal.Title className="table-top">
          {editData ? "Edit Patient Group" : "Create Patient Group"}
        </Modal.Title>
      </Modal.Header>

      {/* ===== Modal Body ===== */}
      <Modal.Body style={{ padding: "16px" }}>
        <Form>
          <Popup
            open={isPopup3Open}
            position="left center"
            offset={[125, 10]}
            style={{ zIndex: 10001 }}
            content={
              <GetStartedPopup
                title="Add Patient Insurance"
                description={
                  <div style={{ marginLeft: "0px", textAlign: "left", fontSize: "14px", color: "#4A4A4A" }}>
                    <ul style={{ paddingLeft: "15px", marginBottom: "0", marginTop: "0" }}>
                      <li style={{ marginBottom: "15px" }}>Enter the following details to add a patient group like:</li>
                      <ol style={{ paddingLeft: "10px", marginBottom: "15px", listStylePosition: "inside" }}>
                        <li style={{ marginBottom: "10px" }}>Group Name</li>
                        <li style={{ marginBottom: "10px" }}>Provider</li>
                        <li style={{ marginBottom: "10px" }}>Status</li>
                        <li style={{ marginBottom: "10px" }}>Start & End Date</li>
                        <li style={{ marginBottom: "10px" }}>Max Attendees</li>
                        <li style={{ marginBottom: "10px" }}>Patients</li>
                      </ol>
                      <li style={{ marginBottom: "0px" }}>After filling all the details. click "Save" button to add a Patient group</li>
                    </ul>
                  </div>
                }
                currentStep={3}
                totalSteps={7}
                onBack={() => {
                  setIsPopup3Open(false);
                  history.replace({
                    pathname: location.pathname,
                    state: { patientgroupstarted2: true },
                  });
                  onClose();
                }}
                onNext={() => {
                  setIsPopup3Open(false);
                  history.replace({
                    pathname: location.pathname,
                    state: { patientgroupstarted4: true },
                  });
                  onClose();
                }}
                onClose={() => {
                  setIsPopup3Open(false);
                  history.replace({
                    pathname: location.pathname,
                    state: {},
                  });
                }}
                width="350px"
              />
            }
            trigger={
              <div style={isPopup3Open ? { zIndex: 10001, position: "relative" } : {}}>
                <Form.Group className="mb-3">
                  <Form.Label>Group Name</Form.Label>
                  <Form.Control
                    type="text"
                    value={groupName}
                    onChange={(e) => {
                      setGroupName(e.target.value);
                      setGroupNameErr(false);
                      setShowMessage(false); // Clear API error when typing
                    }}
                    placeholder="Enter Group Name"
                    className={groupNameErr ? "is-invalid" : ""}
                  />

                  {/* Show validation error OR API error, but not both */}
                  {groupNameErr && !showMessage && (
                    <p className="errormessage">Group name is required</p>
                  )}

                  {/* Show API error (duplicate name) */}
                  {showMessage && messageType === "danger" && (
                    <p className="errormessage" style={{ color: "#dc3545" }}>
                      {messageText}
                    </p>
                  )}
                </Form.Group>
              </div>
            }
          />

          {/* Provider + Status */}
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group className="force-width-createclient">
                <Form.Label>
                  Provider<span style={{ color: "#E23D28" }}>*</span>
                </Form.Label>

                <Select
                  virtual={false}
                  getPopupContainer={() => document.body}
                  placeholder="Select Provider"
                  className="w-100 creat_provider ant-sel-hei34 FutVideoShow staterelative"
                  id="new-app-office"
                  value={providerID || undefined}
                  style={
                    provErr
                      ? { border: "1px solid red", borderTopRightRadius: "5px" }
                      : {}
                  }
                  onChange={(val) => {
                    setproviderID(String(val));
                    setProvErr(false);
                  }}
                  suffixIcon={<CustomSuffixIcon />}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.title ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  dropdownStyle={{ zIndex: 1060 }}
                >
                  {providerlist.map((p) => (
                    <Option key={p.id} value={String(p.id)}>
                      {p.fname} {p.lname}
                    </Option>
                  ))}
                  {provErr && (
                    <p className="errormessage">Please select provider</p>
                  )}
                </Select>

                {provErr && (
                  <p className="errormessage">Please Select Provider</p>
                )}
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="force-width-createclient">
                <Form.Label>
                  Status<span style={{ color: "#E23D28" }}>*</span>
                </Form.Label>

                <Select
                  virtual={false}
                  getPopupContainer={() => document.body} //
                  placeholder="Select Status"
                  className="w-100 creat_provider ant-sel-hei34 FutVideoShow staterelative"
                  value={status}
                  onChange={statusSetVal}
                  dropdownStyle={{ zIndex: 1060 }} //
                >
                  <Option value="active">Active</Option>
                  <Option value="inactive">Inactive</Option>
                  <Option value="expired">Expired</Option>
                </Select>

                {statusErr && (
                  <p className="errormessage">Please Select Status</p>
                )}
              </Form.Group>
            </Col>
          </Row>

          {/* Effective Dates */}
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>Effective Start Date</Form.Label>
                <DatePicker
                  style={{ width: "100%" }}
                  value={startDate ? moment(startDate, "YYYY-MM-DD") : null}
                  format={dtFormat}
                  placeholder={dtFormat}
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  onChange={(date) => {
                    const selectedDate = date ? date.format("YYYY-MM-DD") : "";
                    setStartDate(selectedDate);
                    setDateErr(false);

                    if (endDate && selectedDate > endDate) {
                      setEndDate("");
                    }
                  }}
                />
                {dateErr && (
                  <p className="errormessage">Please select valid start date</p>
                )}
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label>Effective End Date</Form.Label>
                <DatePicker
                  style={{ width: "100%" }}
                  value={endDate ? moment(endDate, "YYYY-MM-DD") : null}
                  format={dtFormat}
                  placeholder={dtFormat}
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  disabledDate={(current) => {
                    return startDate
                      ? current &&
                      current.isBefore(
                        moment(startDate, "YYYY-MM-DD"),
                        "day",
                      )
                      : false;
                  }}
                  onChange={(date) => {
                    setEndDate(date ? date.format("YYYY-MM-DD") : "");
                    setDateErr(false);
                  }}
                />
                {dateErr && (
                  <p className="errormessage">Please select valid end date</p>
                )}
              </Form.Group>
            </Col>
          </Row>

          {/* Max Attendees + Add Patients */}
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>Max Attendees</Form.Label>
                <Form.Control
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  value={maxAttendees}
                  onChange={(e) => {
                    const value = e.target.value;

                    // allow empty (user clearing input)
                    if (value === "") {
                      setMaxAttendees("");
                      setMaxErr(false);
                      return;
                    }

                    // allow ONLY positive whole numbers (1,2,3...)
                    if (/^[1-9][0-9]*$/.test(value)) {
                      setMaxAttendees(value);
                      setMaxErr(false);
                    }
                  }}
                  placeholder="Enter Max Attendees"
                />

                {maxErr && (
                  <p className="errormessage">Enter valid max attendees</p>
                )}
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label>Add Patients</Form.Label>

                <div
                  className="for_autoComplete_bi ElligibiltyProductSearch"
                  style={{
                    width: "140%",
                    marginTop: "2px",
                    marginLeft: "-20px",
                  }}
                >
                  <AiOutlineSearch />
                  <AutoComplete
                    virtual={false}
                    placeholder="Patient"
                    className="remainderWidthSheet"
                    style={{ width: "105%" }}
                    value={search}
                    onSelect={PatientSelect}
                    onChange={PatientSearch}
                    onFocus={() => {
                      if (
                        search === "" &&
                        source.length === 0 &&
                        !forpatsrchload
                      ) {
                        setforpatsrchload(true);
                        patdropdown();
                      }
                    }}
                    disabled={
                      !maxAttendees ||
                      !/^[1-9][0-9]*$/.test(maxAttendees) ||
                      selectedPatients.length >= Number(maxAttendees)
                    }
                    notFoundContent={
                      forpatsrchload ? "loading..." : "No Result Found"
                    }
                    options={source.map((x) => ({
                      value: x.pid + "-" + x.name,
                      label: (
                        <div>
                          <div className="toplabel">
                            {x.title} -{" "}
                            {x.dob ? moment(x.dob).format(dtFormat) : ""}
                          </div>
                        </div>
                      ),
                    }))}
                  />
                </div>
              </Form.Group>
            </Col>
          </Row>

          {/* Patients textarea */}
          <Form.Group>
            <Form.Label>Patients</Form.Label>

            <div
              className="selected-patient-box"
              style={{
                minHeight: "45px",
                border: "1px solid #d9d9d9",
                borderRadius: "2px",
                padding: "6px",
                display: "flex",
                flexWrap: "wrap",
                gap: "6px",
                background: "#fff",
              }}
            >
              {selectedPatients.length === 0 && (
                <span style={{ color: "#999" }}>
                  Selected patients will appear here
                </span>
              )}

              {selectedPatients.map((p) => (
                <span
                  key={p.pid}
                  title={p.title}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    background: "#E6F0FF",
                    borderRadius: "16px",
                    padding: "4px 10px",
                    fontSize: "13px",
                  }}
                >
                  {p.title}

                  <span
                    style={{
                      marginLeft: "8px",
                      cursor: "pointer",
                      fontWeight: "bold",
                    }}
                    onClick={() => removePatient(p.pid)}
                  >
                    ✕
                  </span>
                </span>
              ))}
            </div>
            {/* {patientErr && <p className="errormessage">{patientErr}</p>} */}
          </Form.Group>
        </Form>
      </Modal.Body>

      {/* ===== Modal Footer ===== */}
      <Modal.Footer>
        <Button
          className="close_active close-btn"
          variant="light"
          onClick={() => {
            resetForm();
            onClose();
          }}
        >
          Close
        </Button>

        <Button
          className="save_active save-btn"
          variant="primary"
          onClick={handleSave}
        >
          Save
        </Button>
      </Modal.Footer>
    </>
  );
};

export default memo(CreateGroupClients);
